import { createRESTConn, RESTResponseFormatter } from "../../common";
import { ConnectionNames } from "../../contracts";
import { WildcardRequestFormatter } from "../WildcardRequestFormatter";
export function createWildcardConnection() {
    return createRESTConn({
        name: ConnectionNames.wildcard,
        handlers: {
            requestFormatter: WildcardRequestFormatter,
            responseFormatter: RESTResponseFormatter
        }
    });
}
//# sourceMappingURL=createWildcardConnection.js.map